import React, { useEffect, useRef } from 'react';
import { useDocumentTemplate } from '../../hooks/documentTemplate/useDocumentTemplate';

interface Props {
  id: number | null;
  isOpen: boolean;
  onClose: () => void;
}

const TemplateIframePreviewModal: React.FC<Props> = ({ id, isOpen, onClose }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { htmlPreview, loadHtmlPreview, clearHtmlPreview } = useDocumentTemplate();

  useEffect(() => {
    if (isOpen && id) {
      loadHtmlPreview(id);
    }

    return () => {
      clearHtmlPreview();
    };
  }, [id, isOpen]);

  useEffect(() => {
    if (iframeRef.current && htmlPreview) {
      const doc = iframeRef.current.contentDocument || iframeRef.current.contentWindow?.document;
      if (doc) {
        doc.open();
        doc.write(htmlPreview);
        doc.close();
      }
    }
  }, [htmlPreview]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-black/70 flex items-center justify-center p-4">
      <div className="relative w-full max-w-[90%] h-[90vh] bg-white rounded shadow overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-black hover:text-red-600 text-xl"
        >
          ✕
        </button>

        <iframe
          ref={iframeRef}
          title="Vista Previa Plantilla"
          className="w-full h-full border-0"
        />
      </div>
    </div>
  );
};

export default TemplateIframePreviewModal;
